import { useContext } from 'react';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import { AOIContext } from '../../Contexts/AOIContext';
import UsecaseLinks from './UsecaseLinks';
import { UserContext } from '../../Contexts/UserContext';
import RenderTag from './RenderTag';
import TokensIcon from '../../Assets/img/icon-tokens.png';
import SubscribedTokensIcon from '../../Assets/img/icon-tokens-subscribed.png';
import { MapUtils } from '../MapUtils';
import DeleteIcon from '../../Assets/img/icon-red-trash.svg';
import EditIcon from '../../Assets/img/icon-edit-grey.svg';

const AOIGridCard = (props) => {
    const {user, aoiThumbnails, aoiPrices, usecases} = useContext(UserContext);
    const {showEditAttributes, viewAOIDetails, setZoomToFit, isServiceAvailable, 
        deleteAOI, hasAOIDeletePermission,
        editAOI, hasAOIEditPermission
    } = useContext(AOIContext);

    const setPageParams = () => {
        window.scrollTo(0, 0);
        setZoomToFit(true);
    };

    return (
            <div className="aoi-card">
                <div className="aoi-card-body">
                    <figure>
                        {
                            props.show != "all" && props.show != "links" ?
                                <img src={aoiThumbnails[props.aoi.aoiId]} alt="" onClick={setPageParams} />
                            :
                                <Link to={`/portfolio/map/aoi/${props.aoi.aoiId}`}>
                                    <img src={aoiThumbnails[props.aoi.aoiId]} alt="" onClick={setPageParams} />
                                </Link>
                        }
                    </figure>
                    <div className="aoi-info">
                        <div className="info-row">
                            <h4>AOI Name</h4>
                            <RenderTag tag={props.aoi.name} />
                        </div>
                        <div className="info-row">
                            <h4>Area</h4>
                            <h3>{MapUtils.transformArea(props.aoi.area)}</h3>
                        </div>
                        <div className="info-row">
                            <h4>Last Modified Date</h4>
                            <h3><Moment date={props.aoi.updatedDate} format={"Do MMMM YYYY"}></Moment></h3>
                        </div>
                        <Link to={`/timeline/${props.aoi.aoiId}`}>Timeline</Link>
                    </div>
                    {
                        hasAOIEditPermission &&
                        <a><img src={EditIcon} className='edit-aoi-icon' onClick={()=>editAOI(props.aoi.aoiId)}/></a>
                    }
                    {
                        hasAOIDeletePermission &&
                        <a><img src={DeleteIcon} className='delete-aoi-icon' onClick={()=>deleteAOI(props.aoi.aoiId)}/></a>
                    }
                </div>
            </div>
    );
}

export default AOIGridCard;